import { useState } from 'react';
import { Button } from '@/components/Button';
import WalkthroughLayout from './WalkthroughLayout';

type Props = {
  onComplete: () => void;
};

// TODO: Figmaから各ステップの画像をエクスポートして public/agent/walkthrough/ に配置する
// - step1.png: 連携したいアカウントを選択（ATS一覧のスクリーンショット）
// - step2.png: ログイン、もしくはURLを入力（入力例2つ）
// - step3.png: 求人の取り込み完了（完了画面例）
const PAGES = [
  {
    step: 1,
    title: '連携したいアカウントを選択',
    description: '利用しているATSサービスを選択します。',
    image: '/agent/walkthrough/step1.png',
  },
  {
    step: 2,
    title: 'ログイン、もしくはURLを入力',
    description: 'アカウント情報を入力して連携します。',
    image: '/agent/walkthrough/step2.png',
  },
  {
    step: 3,
    title: '求人の取り込み完了',
    description: '連携が完了すると、求人が自動で取り込まれます。',
    image: '/agent/walkthrough/step3.png',
  },
] as const;

export default function WalkthroughInfoPages({ onComplete }: Props) {
  const [currentPage, setCurrentPage] = useState<number>(0);
  const page = PAGES[currentPage];
  const isLastPage = currentPage === PAGES.length - 1;

  const handleNext = () => {
    if (isLastPage) {
      onComplete();
    } else {
      setCurrentPage((prev) => prev + 1);
    }
  };

  return (
    <WalkthroughLayout>
      <div className="flex h-full flex-col items-center justify-between px-16 py-12">
        {/* ヘッダー */}
        <div className="flex flex-col items-center gap-3">
          <h2 className="my-0 text-center text-2xl font-bold text-black">
            アカウントを連携することで、求人を一括管理できます。
          </h2>
          <p className="text-center text-base text-[#6D6D6D]">3ステップで簡単に連携できます。</p>
        </div>

        {/* コンテンツ */}
        <div className="flex flex-1 flex-col items-center justify-center gap-6">
          {/* ステップ番号と説明 */}
          <div className="flex items-center gap-4">
            <div className="flex size-10 items-center justify-center rounded-full bg-primary text-lg font-bold text-white">
              {page.step}
            </div>
            <div>
              <p className="text-lg font-bold text-black">{page.title}</p>
              <p className="text-sm text-[#6D6D6D]">{page.description}</p>
            </div>
          </div>

          {/* スクリーンショット */}
          <div
            className="overflow-hidden rounded-lg border border-solid border-gray-200"
            style={{ maxWidth: '800px', maxHeight: '360px' }}
          >
            <img
              src={page.image}
              alt={`ステップ${page.step}: ${page.title}`}
              className="size-full object-contain"
            />
          </div>
        </div>

        {/* フッター */}
        <div className="flex flex-col items-center gap-4">
          {/* ページネーションドット */}
          <div className="flex gap-2">
            {PAGES.map((p, index) => (
              <div
                key={p.step}
                className={`size-2.5 rounded-full ${
                  index === currentPage ? 'bg-primary' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>

          {/* ボタン */}
          <Button type="button" onClick={handleNext} className="h-[52px] w-[320px]">
            {isLastPage ? '連携アカウントの設定をする' : '次へ'}
          </Button>
        </div>
      </div>
    </WalkthroughLayout>
  );
}
